<template>
  <div class="pdf-container" :style="`height: ${height}px`" tabindex="0">
    <clientOnly>
      <pdf
        class="pdf-container__pdf"
        v-for="i in numPages"
        :key="i"
        :src="src"
        :page="i"
      ></pdf>
    </clientOnly>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: {
    pdf
  },
  props: {
    src: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      default: 400
    }
  },
  data() {
    return {
      numPages: undefined,
      loadingTask: pdf.createLoadingTask(this.src)
    };
  },
  mounted() {
    this.loadingTask.promise.then(pdf => {
      this.numPages = pdf.numPages;
    });
  }
};
</script>
<style lang="scss" scoped>
@import "../../sass/component.scss";

.pdf-container {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid theme-color("placeholder");

  &__pdf {
    border: 4px solid theme-color("light");
    border-bottom-width: 6px;

    &:last-child {
      border-bottom-width: 4px;
    }
  }
}
</style>
